module.exports = __webpack_public_path__ + "static/images/c6f06e20f24824d9eefefcb6cc1bfa10.svg";